import { applyWindow } from './applyWindow';
import { compose } from './compose';
export function apodization(data, options) {
    const { compose: composeOptions, pointsToShift } = options;
    const windowData = compose(composeOptions);
    const applyWindowOptions = {
        windowData,
        pointsToShift,
    };
    const re = applyWindow(data.re, applyWindowOptions);
    const im = applyWindow(data.im, applyWindowOptions);
    return { re, im, windowData };
}
//# sourceMappingURL=apodization.js.map